import AxiosService from '../../../../gateway/rest/AxiosService'

class CsvWebTokenizerRestService {
    static csvWebTokenizerEndpoint = '/csvwebtokenizer'

    static getTokenizedCsvFiles(): Promise<any> {
        return AxiosService.get(this.csvWebTokenizerEndpoint)
    }

    static async protectCsvFile(csvFile: any): Promise<any> {
        return AxiosService.post(this.csvWebTokenizerEndpoint + '/protect', csvFile)
    }

    static async unveilCsvFile(csvFile: any): Promise<any> {
        return AxiosService.post(this.csvWebTokenizerEndpoint + '/unveil', csvFile)
    }

    static deleteCsvFile(id: number): Promise<any> {
        return AxiosService.delete(this.csvWebTokenizerEndpoint + '/' + id)
    }

    static downloadCsvFile(id: number): Promise<any> {
        return AxiosService.get(this.csvWebTokenizerEndpoint + '/' + id, { responseType: 'blob' })
    }
}

export default CsvWebTokenizerRestService